const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  add ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-comment/add', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-comment/update', params)
  },
  childList ({ state, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review-comment/child-list', { params })
  },
  reviewReplyList ({ dispatch, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review-comment/review-reply-list', { params })
      .then(async (res) => {
        res.data.list = await dispatch('format', res.data.list)
        return res
      })
  },
  format (_, list) {
    return list.map(item => {
      const images = typeof item.images === 'string' ? JSON.parse(item.images) : item.images

      return {
        ...item,
        images,
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
